export class State {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default State;